import { ButtonWithIcon, Button } from '@/components/atoms'
import { COLOR } from '@/utils/constants/colors'
import { SIZE } from '@/utils/constants/globalStyle'
import { Font } from 'pepsico-ds'
import { useFormContext } from "react-hook-form"
import { Dropdown } from "@/components/atoms"
import { TextInputField } from '@/components/molecules'
import { useIntl } from 'react-intl'

const Item = ({ data, handleChange, handleDelete, index }) => {
  const { formatMessage } = useIntl()
  const handleActivity = (value) => {
    const selectedActivity = value[0];
    if (selectedActivity) {
      handleChange(index, {
        ...data,
        activityID: selectedActivity.id,
        activityName: selectedActivity.displayText,
      })
    }
  }

  const handleMultiplier = (value) => {
    if (value) {
      const multiplier = parseFloat(value)
      handleChange(index, {
        ...data,
        multiplier: multiplier
      })
    }
  }

  return (
    <div className="flex w-full items-center h-12" data-testid="item">
      <div className='flex items-start gap-4'>
        <Dropdown
          placeholder={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_PLACEHOLDER' })}
          isDark
          childList={[
            {
              id: '1',
              displayText: 'Activity 1',
            },
            {
              id: '2',
              displayText: 'Activity 2',
            },
            {
              id: '3',
              displayText: 'Activity 3',
            },
          ]}
          value={[{ id: data?.activityID || '', displayText: data?.activityName || '' }]}
          updateValue={handleActivity}
          isJsonWrap={false}
        />
        <TextInputField
          isDark
          value={data?.multiplier}
          updateValue={handleMultiplier}
          visible
          uiSchema={{
            placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_TEXT_PLACEHOLDER' }),
            isDark: true,
          }}
        />
      </div>
      {index > 0 ? (
        <Button
          handleButton={() => handleDelete(index)}
          uiSchema={{
            className: 'ml-4',
            title: 'Delete',
            variant: 'tertiary',
            size: 'medium',
          }}
          style={{ marginLeft: '-50%', marginBottom: '.5rem', zIndex: '10' }}
        />
      ) : null}
    </div>
  )
}

export const ActivitiesSelector = () => {
  const { formatMessage } = useIntl()
  const { setValue, getValues } = useFormContext();
  const activities = getValues('activities');

  const handleChange = (index, newValue) => {
    setValue(`activities.${index}`, newValue);
  }

  const handleDelete = index => {
    const nextActivities = activities.filter((_, currentIndex) => currentIndex !== index)
    setValue('activities', nextActivities);
  }

  const createNewActivity = () => {
    const nextActivities = [
      ...activities,
      {
        activityID: '',
        activityName: '',
        multiplier: 0
      }
    ];

    setValue('activities', nextActivities);
  }

  console.log('activities', activities)
  return (
    <>
      <Font variant="bold" size="body" textColorClass="text-white" className="mb-5">
        {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_TITLE' })}
      </Font>
      {activities.map((activity, index) => (
        <Item data={activity} handleChange={handleChange} handleDelete={handleDelete} key={index} index={index} />
      ))}
      <ButtonWithIcon
        uiSchema={{
          className: 'flex items-center text-[#0069D7] border-none',
          title: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ADD_ACTIVITY' }),
          size: SIZE.SMALL,
          variant: COLOR.TERTIARY,
          isDark: true,
        }}
        iconLeading="add_box"
        handleButton={createNewActivity}
      />
    </>
  )
}
